import classNames from "classnames";
import { useExpandStore } from "../common/store";
import { CardsContainerProps } from "./definitions";

export const CardsContainer = ({
  children,
  className,
}: CardsContainerProps) => {
  const [expanded] = useExpandStore();

  if (children.length > 2) {
    console.error("Children inside CardContainer must not be more than 2.");
    throw new Error("CardsContainer can only have 2 children");
    // return <div>Children inside CardContainer must not be more than 2.</div>;
  }

  return (
    <section
      className={`grid h-full w-full grid-cols-12 grid-rows-6 gap-16 ${className}`}
    >
      {/* if not an array, then expand the 12 columns */}
      {!children.length && (
        <div className="col-span-full row-span-full h-full w-full">
          {children}
        </div>
      )}

      {/* if an array, share 50/50 columns unless expanded */}
      {children.length === 2 && (
        <>
          <div
            className={`row-span-full h-full w-full ${classNames({
              ["col-span-6"]: !expanded,
            })} ${classNames({
              ["col-span-3"]: expanded,
            })}`}
          >
            {children[0]}
          </div>
          <div
            className={`row-span-full h-full w-full ${classNames({
              ["col-span-6"]: !expanded,
            })} ${classNames({
              ["col-span-9"]: expanded,
            })}`}
          >
            {children[1]}
          </div>
        </>
      )}
    </section>
  );
};
